module.exports = __webpack_public_path__ + "static/mtb-4-7c4d225662bc8c6dd290b87537832487.jpg";